import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Selectors } from '@grandvisionhq/auth';
import { Context } from '@grandvisionhq/carts-v2';
import { toast } from '@grandvisionhq/common';
import { Util } from '@grandvisionhq/forms';
import { useLink } from '@grandvisionhq/frk-routing';
import { useSync } from '@grandvisionhq/lib-utils-w3c';
import { WithUserData } from '@grandvisionhq/my-account';
import { useIntl, useDispatch, useSelector, useFeatureToggles } from '@grandvisionhq/state';
import { init, initOrder } from '../actions.js';
import { useCheckoutSettings } from '../context/CheckoutSettings/context.js';
import '@grandvisionhq/graphql';
import '@grandvisionhq/payments';
import '@grandvisionhq/utils';
import '@grandvisionhq/api-client';
import { resetMyAccountValidation, toggleDeliveryAddress, markFieldsTouched, setMyAccountValidation, setServiceStoreValidation, toggleIsCompany } from './actions.js';
import { getCompany, isBillingAndShippingAddressSame, isShippingStepValid, isPrefillFinished, getSelectedShippingMethod, hasStoredDeliveryAddress, getBillingAddress, getSelectedPostalCode } from './selectors.js';
import { getServiceStore, shouldCreateAccount } from '../selectors.js';
import '@grandvisionhq/lib-utils-cart';
import '../mappers/errors-mapping.js';
import '../operations/mutations/set-customer-details.js';
import '../operations/mutations/set-shipping-method.js';
import '../operations/mutations/set-shipping-state.js';
import '../operations/mutations/set-store.js';
import '../operations/mutations/create-apple-pay-session.js';
import '../operations/mutations/recreate-ordered-checkout.js';
import 'lodash/isEmpty';
import '../utils/get-customer-details-payload.js';
import { isDelivery, isDeliveryExpress } from '../utils/shipping-method.js';
import 'history';
import '../models/cart/cart-state.js';
import '../models/checkout/checkout-step-error-type.js';
import '../models/checkout-settings.js';
import { ShippingMethod } from '../models/step-shipping/shipping-methods.js';
import '../models/shared.js';
import '../utils/has-cart-errors.js';
import { useSetShippingState } from '../hooks/operations/use-set-shipping-state.js';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/analytics';
import '../operations/fragments/checkout-mutation-result.js';
import '../operations/fragments/cart-mutation-failures.js';
import '../operations/fragments/recreate-ordered-checkout-failure.js';
import '../operations/fragments/recreate-ordered-checkout-result.js';
import '../operations/fragments/paypal-payment.js';
import '../operations/fragments/saved-user-details.js';
import '../operations/queries/get-checkout-state.js';
import '../operations/queries/get-user-details.js';
import { useFormSlot } from '../slots/forms/form-context.js';
import '../slots/summaries/summary-context.js';
import '../slots/summaries/types.js';
import { CustomerType } from '../types.js';
import { useFormPrefill } from './hooks/use-form-prefill.js';
import { StepShipping } from './StepShipping.js';

const StepShippingContainer = ({ onNextStep , onPrevStep , shippingMethodsAsides , userData , isCartLoading =true ,  })=>{
    var ref7, ref1, ref2, ref3, ref4, ref5, ref6;
    const checkoutSettings = useCheckoutSettings();
    const { getLabel , country  } = useIntl();
    const dispatch = useDispatch();
    useFormPrefill(userData);
    const company = useSelector(getCompany);
    const isLoggedIn = useSelector(Selectors.isLoggedIn);
    const billingAndDeliverySame = useSelector(isBillingAndShippingAddressSame);
    const { billingAddress , deliveryAddress  } = useFormSlot();
    const isShippingStepValidBoolean = useSelector(isShippingStepValid);
    const isPrefillFinished$1 = useSelector(isPrefillFinished);
    const selectedShippingMethod = useSelector(getSelectedShippingMethod);
    const selectedServiceStore = useSelector(getServiceStore);
    const shouldCreateAccountBoolean = useSelector(shouldCreateAccount);
    const hasStoredDeliveryAddressBoolean = useSelector(hasStoredDeliveryAddress);
    const billingAddressDetails = useSelector(getBillingAddress);
    const postalCode = useSelector(getSelectedPostalCode);
    const isCreateAccountRequired = Boolean(((ref7 = checkoutSettings.account) === null || ref7 === void 0 ? void 0 : ref7.implicitAccountCreation) || ((ref1 = checkoutSettings.account) === null || ref1 === void 0 ? void 0 : ref1.createAccountRequired));
    const { allowAlternativeShippingState , featureConfigs  } = useFeatureToggles();
    const { onClick: navigateToCart  } = useLink({
        route: 'cart.overview'
    }, {
        replace: true
    }) || {};
    const broadCastChannel = useSync('new-cart-created').getChannel();
    broadCastChannel.onmessage = ()=>{
        toast.failed('cart.errors.cartNotInActiveState');
        navigateToCart === null || navigateToCart === void 0 ? void 0 : navigateToCart();
    };
    const [isOptInsFetching, setIsOptInsFetching] = React.useState(true);
    const [showAlternateShippingModal, setShowAlternateShippingModal] = React.useState(false);
    const { cart  } = Context.useCart();
    const isCompanyEnabled = (ref2 = checkoutSettings.features) === null || ref2 === void 0 ? void 0 : ref2.isCompanyEnabled;
    const isServiceStoreEnabled = (ref3 = checkoutSettings.features) === null || ref3 === void 0 ? void 0 : ref3.isServiceStoreEnabled;
    const isDeliveryAddressRequired = (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method) === ShippingMethod.Delivery && ((ref4 = checkoutSettings.shipping) === null || ref4 === void 0 ? void 0 : ref4.requiredShippingCountry) && (billingAddressDetails === null || billingAddressDetails === void 0 ? void 0 : billingAddressDetails.country) && checkoutSettings.shipping.requiredShippingCountry !== billingAddressDetails.country;
    const regex = featureConfigs.alternativeShippingRegex ? new RegExp(featureConfigs.alternativeShippingRegex) : undefined;
    const isShippingMethodStateValid = ()=>{
        const postalCodeIsValid = postalCode && !(regex === null || regex === void 0 ? void 0 : regex.test(postalCode));
        return Boolean(postalCodeIsValid) && postalCode;
    };
    const handleSetShippingStateCompleted = React.useCallback((cartId)=>{
        if (cartId) {
            setShowAlternateShippingModal(true);
        } else {
            onNextStep();
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onNextStep
    ]);
    const { setShippingState: setShippingStateWithCallback  } = useSetShippingState({
        onCompleted: handleSetShippingStateCompleted
    });
    const { setShippingState  } = useSetShippingState();
    const resetShippingState = React.useCallback(()=>{
        if (cart === null || cart === void 0 ? void 0 : cart.hasAlternativeShippingState) {
            setShippingState(country);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cart === null || cart === void 0 ? void 0 : cart.hasAlternativeShippingState,
        country
    ]);
    const isStepValid = ()=>{
        var ref;
        return isShippingStepValidBoolean && (!isServiceStoreEnabled || !!selectedServiceStore || isServiceStoreEnabled && Boolean((ref = checkoutSettings.serviceStore) === null || ref === void 0 ? void 0 : ref.isOptional)) && (isLoggedIn || !isCreateAccountRequired || shouldCreateAccountBoolean);
    };
    // Reset the shipping state on the back-end to ensure all shipping methods are fetched, avoiding a restricted subset.
    React.useEffect(()=>{
        if (cart === null || cart === void 0 ? void 0 : cart.id) {
            resetShippingState();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cart === null || cart === void 0 ? void 0 : cart.id
    ]);
    React.useEffect(()=>{
        if (!isCreateAccountRequired) {
            dispatch(resetMyAccountValidation());
        }
    // This should be called only when createAccountRequired flag changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isCreateAccountRequired
    ]);
    const onToggleIsCompany = (radio)=>{
        dispatch(toggleIsCompany({
            enabled: radio.value === CustomerType.Company
        }));
    };
    const onToggleDeliveryAddress = ({ checked  })=>{
        if (isDeliveryAddressRequired) {
            toast.failed('checkout.address.requiredShippingCountry.errorMessage');
        } else {
            dispatch(toggleDeliveryAddress({
                enabled: !checked
            }));
        }
    };
    React.useEffect(()=>{
        dispatch(init());
        dispatch(initOrder());
    }, [
        dispatch
    ]);
    React.useEffect(()=>{
        /**
     * To ensure that the delivery address is prefilled, it is necessary to  enable the
     * delivery form in advance. However, it is important to note that this requirement
     * is applicable only to the "Delivery" and "DeliveryExpress" shippingMethod options.
     */ if (!billingAndDeliverySame && hasStoredDeliveryAddressBoolean && ((selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method) === ShippingMethod.Delivery || (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method) === ShippingMethod.DeliveryExpress)) {
            dispatch(toggleDeliveryAddress({
                enabled: true
            }));
        }
    /**
     *  This hook should only be executed during the on mount process.
     */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    React.useEffect(()=>{
        if (isDeliveryAddressRequired) {
            dispatch(toggleDeliveryAddress({
                enabled: true
            }));
        }
    }, [
        isDeliveryAddressRequired,
        dispatch
    ]);
    const nextStep = React.useCallback((bypassValidation = false)=>{
        if (!isStepValid() && !bypassValidation) {
            var ref;
            dispatch(markFieldsTouched());
            if (isCreateAccountRequired && !shouldCreateAccountBoolean) {
                dispatch(setMyAccountValidation());
            }
            if (isServiceStoreEnabled && !((ref = checkoutSettings.serviceStore) === null || ref === void 0 ? void 0 : ref.isOptional)) {
                dispatch(setServiceStoreValidation());
            }
            toast.failed('checkout.errors.form.general');
            Util.focusToTopErrorFieldOnScreen();
        } else if (allowAlternativeShippingState && !bypassValidation && !isShippingMethodStateValid()) {
            postalCode && setShippingStateWithCallback(country, postalCode);
        } else {
            onNextStep();
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        allowAlternativeShippingState,
        (ref5 = checkoutSettings.serviceStore) === null || ref5 === void 0 ? void 0 : ref5.isOptional,
        country,
        isCreateAccountRequired,
        isServiceStoreEnabled,
        isShippingMethodStateValid,
        isStepValid,
        postalCode,
        shouldCreateAccountBoolean, 
    ]);
    /**
   *  Callback from OptInContainer to return
   *  loading state of OptIns from GraphQL call
   *
   *  @param isOptInsLoading
   *    flag to return loading state of OptIns
   */ const handleOptInsLoading = React.useCallback(({ isOptInsLoading  })=>{
        setIsOptInsFetching(isOptInsLoading);
    }, []);
    const handleCloseAlternateShippingModal = React.useCallback(()=>{
        setShowAlternateShippingModal(false);
        resetShippingState();
    }, [
        resetShippingState
    ]);
    const showLoader = isOptInsFetching || !isPrefillFinished$1;
    const labels = React.useMemo(()=>({
            generic: {
                title: getLabel('checkout.generic.title')
            },
            customerType: {
                private: getLabel('checkout.customerType.private'),
                company: getLabel('checkout.customerType.company')
            },
            shipmentMethodTitle: getLabel('checkout.shipment.method.title'),
            serviceStoreTitle: getLabel('checkout.serviceStore.title'),
            serviceStoreSubtitle: getLabel('checkout.serviceStore.subtitle'),
            alternativeShippingMethodTitle: getLabel('checkout.shipment.method.alternative.modal.title')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(StepShipping, {
        billingAddressForm: billingAddress,
        deliveryAddressForm: deliveryAddress,
        company: Boolean(company),
        isCompanyEnabled: Boolean(isCompanyEnabled),
        isDelivery: isDelivery(selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method),
        isDeliveryExpress: isDeliveryExpress(selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method),
        labels: labels,
        onNextStep: nextStep,
        onPrevStep: onPrevStep,
        routes: checkoutSettings === null || checkoutSettings === void 0 ? void 0 : checkoutSettings.routes,
        shippingMethodsAsides: shippingMethodsAsides,
        showLoader: showLoader && !isCartLoading,
        toggleDeliveryAddress: onToggleDeliveryAddress,
        toggleIsCompany: onToggleIsCompany,
        handleOptInsLoading: handleOptInsLoading,
        enableServiceStoreValidation: !((ref6 = checkoutSettings.serviceStore) === null || ref6 === void 0 ? void 0 : ref6.isOptional),
        showAlternateShippingModal: showAlternateShippingModal,
        handleCloseAlternateShippingModal: handleCloseAlternateShippingModal
    });
};
const StepShippingContainerWithUserData = WithUserData(StepShippingContainer);
const StepShippingContainerWithMyAccount = (_param)=>{
    var props = swcHelpers.extends({}, _param);
    const { isMyAccountEnabled  } = useFeatureToggles();
    return /*#__PURE__*/ React.createElement(StepShippingContainerWithUserData, swcHelpers.extends({}, props, {
        isMyAccountEnabled: isMyAccountEnabled
    }));
};

export { StepShippingContainerWithMyAccount as default };
//# sourceMappingURL=StepShippingContainer.js.map
